import moment from 'moment'
import clients from 'redux/clients'

export const FETCH_PARTICIPANT = 'participant/FETCH'
export const FETCH_PARTICIPANT_SUCCESS = `${FETCH_PARTICIPANT}_SUCCESS`
export const FETCH_PARTICIPANT_FAIL = `${FETCH_PARTICIPANT}_FAIL`

export const fetchParticipant = () => ({
  type: FETCH_PARTICIPANT,
  payload: {
    client: 'cloudloyalty',
    request: {
      method: 'get',
      url: '/v1/participants/me'
    }
  }
})

export const update = data => {
  return (dispatch, _) => {
    dispatch({ type: 'UPDATE_PARTICIPANT' })

    const handleSuccess = response => {
      dispatch(updateSuccess())
      dispatch(fetchParticipant())
    }
    const handleError = err => dispatch(updateItemFail(err))

    clients.cloudloyalty.client
      .put('/v1/participants/me', data)
      .then(handleSuccess)
      .catch(handleError)
  }
}

const updateSuccess = () => ({
  type: 'UPDATE_PARTICIPANT_SUCCESS',
  payload: null
})

const updateItemFail = err => ({
  type: 'UPDATE_PARTICIPANT_FAIL',
  error: { data: err }
})

export const expireUpdatedParticipant = () => ({ type: 'EXIPIRE_UPDATED_PARTICIPANT' })

export const cleanError = () => ({ type: 'CLEAN_ERROR_PARTICIPANT' })

const selectParticipantPhones = (phones, { readOnlyPhone }) => {
  const defaultPhones = {
    home: { areaCode: '', number: '', type: 'HOME' },
    mobile: { areaCode: '', number: '', type: 'MOBILE' },
    work: { areaCode: '', number: '', type: 'WORK' }
  }
  if (!phones || phones.length === 0) return defaultPhones

  const home = 'HOME'
  const mobile = 'MOBILE'
  const work = 'WORK'

  const matchPhone = (prev, { areaCode, number, type }) => {
    switch (type) {
      case home:
        return {
          ...prev,
          home: {
            areaCode,
            number,
            disabled: readOnlyPhone,
            type
          }
        }
      case mobile:
        return {
          ...prev,
          mobile: {
            areaCode,
            number,
            disabled: readOnlyPhone,
            type
          }
        }
      case work:
        return {
          ...prev,
          work: {
            areaCode,
            number,
            disabled: readOnlyPhone,
            type
          }
        }
      default:
        return { ...prev }
    }
  }

  return phones.reduce(matchPhone, defaultPhones)
}

export const buildPhone = (phone, type) => {
  if (!phone) {
    return { areaCode: '', number: '', type }
  }

  const onlyNumbers = getOnlyNumbers(phone)
  return {
    areaCode: onlyNumbers.substr(0, 2),
    number: onlyNumbers.substr(2),
    type
  }
}

export const getOnlyNumbers = value => {
  const numberPattern = /\d+/g
  return value.match(numberPattern).join([])
}

const initialState = {
  isLoading: true,
  isUpdating: false,
  hasError: false,
  updatedSuccessfully: false,
  name: {},
  cpf: {},
  cnpj: {},
  mails: {},
  email: {},
  address: {
    addressText: {},
    number: {},
    complement: {},
    district: {},
    city: {},
    state: {},
    zipCode: {},
    reference: {}
  },
  phones: {}
}

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PARTICIPANT:
      return { ...state, isLoading: true }
    case FETCH_PARTICIPANT_SUCCESS:
      const participant = action.payload.data
      const {
        catalogParameters,
        address,
        documentNumber,
        emails,
        persontypeId,
        genderTypeId,
        birthDate,
        maritalStatusId,
        profileId,
        statusId,
        companyName,
        name,
        clientId,
        catalogId
      } = participant

      const phones = selectParticipantPhones(participant.phones, catalogParameters)

      return {
        ...state,
        isLoading: false,
        personType: persontypeId,
        isCompany: persontypeId === 2,
        profileId,
        statusId,
        genderType: {
          value: genderTypeId,
          disabled: catalogParameters.readOnlyGenderType
        },
        birthDate: {
          value: birthDate ? moment.utc(birthDate).format('DD/MM/YYYY') : '',
          disabled: catalogParameters.readOnlyBirthDate
        },
        maritalStatus: {
          value: maritalStatusId,
          disabled: catalogParameters.readOnlyMaritalStatus
        },
        name: {
          value: name,
          disabled: catalogParameters.readOnlyName
        },
        companyName: {
          value: companyName == null ? name : companyName,
          disabled: catalogParameters.readOnlyCompanyName
        },
        cpf: {
          value: documentNumber,
          disabled: catalogParameters.readOnlyCpfCnpj
        },
        cnpj: {
          value: documentNumber,
          disabled: catalogParameters.readOnlyCpfCnpj
        },
        cpfCnpj: {
          value: documentNumber,
          disabled: catalogParameters.readOnlyCpfCnpj
        },
        mails: {
          value: emails,
          disabled: catalogParameters.readOnlyEmail
        },
        email: {
          value:
              emails.length > 0 ? emails[0].email : '',
          disabled: catalogParameters.readOnlyEmail
        },
        address:
            address
              ? {
                addressText: {
                  value: address.street,
                  disabled: catalogParameters.shippingAddess
                },
                number: {
                  value: address.number,
                  disabled: catalogParameters.shippingAddessNumber
                },
                complement: {
                  value: address.complement,
                  disabled: catalogParameters.shippingAddessComplement
                },
                district: {
                  value: address.district,
                  disabled: catalogParameters.shippingAddessDistrict
                },
                city: {
                  value: address.city,
                  disabled: catalogParameters.shippingAddessCity
                },
                state: {
                  value: address.state,
                  disabled: catalogParameters.shippingAddessState
                },
                zipCode: {
                  value: address.zipCode,
                  disabled: catalogParameters.shippingZipCode
                },
                reference: {
                  value: address.reference,
                  disabled: 'false'
                }
              }
              : {
                addressText: {
                  value: '',
                  disabled: catalogParameters.shippingAddess
                },
                number: {
                  value: '',
                  disabled: catalogParameters.shippingAddessNumber
                },
                complement: {
                  value: '',
                  disabled: catalogParameters.shippingAddessComplement
                },
                district: {
                  value: '',
                  disabled: catalogParameters.shippingAddessDistrict
                },
                city: {
                  value: '',
                  disabled: catalogParameters.shippingAddessCity
                },
                state: {
                  value: '',
                  disabled: catalogParameters.shippingAddessState
                },
                zipCode: {
                  value: '',
                  disabled: catalogParameters.shippingZipCode
                },
                reference: {
                  value: '',
                  disabled: 'false'
                }
              },
        phones,
        clientId,
        catalogId
      }
    case FETCH_PARTICIPANT_FAIL:
      return { ...state, isLoading: false }
    case 'UPDATE_PARTICIPANT':
      return { ...state, isUpdating: true, updatedSuccessfully: false }
    case 'UPDATE_PARTICIPANT_SUCCESS':
      return {
        ...state,
        isUpdating: false,
        hasError: false,
        updatedSuccessfully: true
      }
    case 'UPDATE_PARTICIPANT_FAIL':
      return {
        ...state,
        isUpdating: false,
        updatedSuccessfully: false,
        hasError: true
      }
    case 'EXIPIRE_UPDATED_PARTICIPANT':
      return {
        ...state,
        updatedSuccessfully: false
      }
    case 'CLEAN_ERROR_PARTICIPANT':
      return {
        ...state,
        hasError: false
      }
    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/Participant/ducks.js